import { supabase } from '@/integrations/supabase/client'
import { clearActing } from '@/lib/acting'

/**
 * Signs the user out in this browser only,
 * clears "acting as" state, and returns control to caller.
 * Caller should redirect afterwards.
 */
export async function appSignOut(): Promise<void> {
  try {
    // "local" avoids revoking refresh tokens on other devices/sessions.
    await supabase.auth.signOut({ scope: 'local' })
  } catch (err) {
    console.error('[signout] supabase signOut error:', err)
    // Even if Supabase throws, we still clean up local client state below.
  } finally {
    clearActing()

    // Best-effort: close realtime channels (no-ops if none).
    try { 
      supabase.removeAllChannels?.() 
    } catch {}

    // Clear any session storage
    try {
      sessionStorage.clear()
    } catch {}

    // If you use React Query / TanStack Query:
    // import { queryClient } from '@/lib/queryClient'
    // try { queryClient.clear() } catch {}
  }
}
